<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title" translate>
    {{pdfToolTip}}
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="OnClose()" aria-label="Center Align">

    <span aria-hidden="true">
      ×
    </span>
  </button>
</div>

<div class="p-3">
  <div class="row" style="margin-bottom: 10px;">
    <div class="col" *ngIf="!isDownloadOrder">
      <select class="form-control" name="id" (change)="OnChange($event)">
        <option selected translate [ngValue]=0 disabled>lblSelectPDFType</option>
        <option *ngFor="let type of pdfType" [ngValue]="type.id" [selected]="type.id == pdfType.id">
          {{type.type}}
        </option>
      </select>
    </div>
    <div class="col" *ngIf="isDownloadOrder">
      <div class="col mb5">
        <div class="form-row">
          <div class="col-auto">
            <div class="p-0">
              <input type="radio" id="idOrderDocument" [(ngModel)]="documentTypeId" name="sourceType"
                (change)="OnDocumentTypeChange(0)" [value]="0" class="radio-custom" />
              <label class="form-check-label" for="idAll" translate>lblOrderDocument</label>
            </div>
          </div>
          <div class="col-auto">
            <div class="p-0">
              <input type="radio" id="idWarrantyDoc" [(ngModel)]="documentTypeId" name="sourceType"
                (change)="OnDocumentTypeChange(1)" [value]="1" class="radio-custom" />
              <label class="form-check-label" for="idPlanner" translate>lblWarrantyDocument</label>
            </div>
          </div>
          <div class="col-auto ml-auto">
            <app-pdf-view [isDownloadOrder]="isDownloadOrder" [isWithoutPrice]="isWithoutPrice"></app-pdf-view>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="af-form-group" *ngIf="documentTypeId == 0">
          <div class="form-check pl-0 mb-2">
                <input type="checkbox" id="isWithoutPrice" [(ngModel)]="isWithoutPrice" class="mr-2"/>
                <label style="display: inline;" translate>lblHidePrice</label>
            </div>      
          <label translate>lblChoosePayer</label>
          <div class="lbl-info pdfdropdown">
            <ng-multiselect-dropdown [data]="groupedDemandList" appendTo="body" (onSelect)="OnPayerChange($event, true)"
              (onDeSelect)="OnPayerChange($event, false)" placeholder="{{ 'lblChoosePayer'| translate}}"
              [settings]="dropdownSettings" [ngModelOptions]="{standalone: true}"
              (onSelectAll)="onSelectAllPayer($event,true)" (onDeSelectAll)="onSelectAllPayer($event,false)">
            </ng-multiselect-dropdown>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer" *ngIf="!isDownloadOrder">
  <app-pdf-view [isDownloadOrder]="isDownloadOrder" [isWithoutPrice]="isWithoutPrice"></app-pdf-view>
</div>